<template>
  <div class="main">
    <div class="banner">
      <van-image
        class="bannerImg"
        fit="cover"
        src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/1.png"
      />
      <div class="logo">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/2.png" alt="">
      </div>
    </div>
    <div class="introduce">
      <div>
        <video width="" height="" src="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/40002/101/reWSitABiT1616421699058.mp4" autoplay="autoplay" controls></video>
        <div class="desc">
          机械MR互动教学是以培养学生共同协作及动手能力为重点，结合优质教学内容硬件终端、应用平台，为高职高校学生创设接近真实的学习环境，将复杂的知识点、昂贵或稀缺的设备立体展现，让师生自由教学。
        </div>
      </div>
    </div>
    <div class="classify">
      <div>
        <!-- 第一行 -->
        <div class="one">
          <div></div>
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/4.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/5.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/6.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/7.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/8.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/9.png" class="list" alt="">
        </div>
        <!-- 第二行 -->
        <div class="two">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/10.png" alt="">
          <div>
            <span>因元件绝版造成课</span>
            <span>程缺失</span>
          </div>
          <div>
            <span>需直接接触真机</span>
            <span>实操课程危险性高</span>
          </div>
          <div>
            <span>需在教学现场</span>
            <span>完成实操课程</span>
          </div>
          <div>
            <span>因真机成本昂贵</span>
            <span>造成课程缺失</span>
          </div>
          <div>
            <span>因数量及可操作性限制</span>
            <span>教学效率低</span>
          </div>
          <div>
            <span>教学单一，课程内容抽象枯燥不易理解，难以创新</span>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="three">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/11.png" alt="">
          <div>
            <span>课件多达<span>2000+</span> </span>
            <span>完全覆盖教学大纲</span>
          </div>
          <div>
            <span>纯虚拟机械模型教学，</span>
            <span><span>0距离0事故</span></span>
          </div>
          <div>
            <span>灵活方便 </span>
            <span> <span>随时随地</span>开展教学</span>
          </div>
          <div>
            <span>低成本，无需造价昂</span>
            <span>贵的实物机械</span>
          </div>
          <div>
            <span>高效教学，多人同时</span>
            <span>可独立或协作，<span>反复</span></span>
            <span><span>操作</span>练习</span>
          </div>
          <div>
            <span>顶尖科技+教学， <span>沉浸式</span></span>
            <span>多维学习体验，生动具</span>
            <span>象，加深记忆力</span>
          </div>
        </div>
      </div>
    </div>
    <div class="scene">
      <div>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/12.png" alt="" class="title">
        <div class="content">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/3.png" alt="">
          <div>
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/38.png?x-oss-process=image/resize,m_fill,h_256,w_396" alt="">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/39.png?x-oss-process=image/resize,m_fill,h_256,w_396" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/13.png" alt="" class="title">
      <div class="list">提供“智能化硬件+常态化应用+数字化内容+数据化服务”解决方案，全方位为教育变革深度赋能。</div>
      <div class="list"> <span>100+VR</span> 软件著作权</div>
      <div class="list"> <span>20+</span> 行业发明专利</div>
      <div class="list">5G教育云平台教学内容总保有量全球领先</div>
      <div class="list"> <span>1000+</span> 项目落地，覆盖 <span>全球10多个国家</span> </div>
      <div class="more"  @click="go">
        <span>了解更多方案</span>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/14.png" alt="">
      </div>
    </div>
    <div class="footer">
      <div>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/two.jpg" alt="">
        <div class="desc">
          <div>官方热线：</div>
          <div>400-888-1126</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
 
  },
  mounted() {
 
  },
  methods: {
    go(){
      window.scrollTo(0, 0)
      this.$router.push({
        name: 'index'
      })
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  .banner{
    width: 100%;
    height: 500px;
    position: relative;
    .bannerImg{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top:0;
    }
    .logo{
      width: 1200px;
      margin: 0 auto;
      padding-top: 2px;
      position: relative;
      z-index: 100;
      img{
        width: 111px;
        margin-top: 40px;
      }
    }
  }
  .introduce{
    width: 100%;
    height: 543px;
    background: #fff;
    > div{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      video{
        width: 631px;
        height: 386px;
      }
      .desc{
        font-size: 24px;
        width: 533px;
        margin-left: 30px;
        font-weight: 400;
        color: #000000;
        line-height: 50px;
      }
    }
  }
  .classify{
    width: 100%;
    height: 506px;
    background: #F6F6F6;
    > div{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding-top: 1px;
      .one{
        width: 100%;
        display: flex;
        margin-top: 45px;
        > div{
          width: 59px;
          height: 61px;
        }
        img{
          width: 190px;
          height: 61px;
        }
      }
      .two, .three{
        width: 100%;
        display: flex;
        img{
          width: 59px;
          height: 175px;
        }
        > div{
          width: 190px;
          height: 175px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          // padding: 0 10px;
          > span{
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 22px;
            display: block;
            text-align: center;
            span{
              font-size: 16px;
              font-weight: 400;
              line-height: 22px;
              color: #FF7211;
            }
          }
          border-bottom: 2px solid #fff;
        }
        > div:nth-child(2n-1){
          background: #fff;
        }
        > div:nth-child(2n){
          background: #F0EFEF;
        }
      }
      .three > div{
        border-bottom: none;
      }
    }
  }
  .scene{
    background: #fff;
    height: 672px;
    > div{
      width: 1200px;
      margin: 0 auto;
      padding-top: 1px;
      .title{
        margin: 0 auto;
        display: block;
        width: 253px;
        margin-top: 35px;
      }
      .content{
        display: flex;
        margin-top: 28px;
        > img{
          width: 800px;
          height: 533px;
        }
        > div{
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
          margin-left: 3px;
          img{
            width: 396px;
            height: 265px;
          }
        }
      }
    }
  }
  .advantage{
    width: 100%;
    padding-top: 1px;
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #F6F6F6;
    > img{
      display: block;
      width: 222px;
      margin: 0 auto;
      margin-top: 32px;
      margin-bottom: 32px;
    }
    .list{
      font-size: 26px;
      font-weight: 600;
      color: #000000;
      line-height: 50px;
      margin-bottom: 39px;
      span{
        font-size: 26px;
        font-weight: 500;
        color: #F27D2C;
        line-height: 22px;
      }
    }
    .more{
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 48px;
      margin-bottom: 60px;
      span{
        font-size: 26px;
        font-weight: 400;
        color: #7E92B5;
        line-height: 50px;
      }
      img{
        width: 23px;
        margin-left: 10px;
      }
    }
  }
  .footer{
    width: 100%;
    height: 267px;
    background: #0B0114;
    padding-top: 1px;
    > div{
      width: 1200px;
      height: auto;
      margin: 0 auto;
      display: flex;
      align-items: center;
      margin-top: 46px;
      > img{
        width: 175px;
        margin-right: 20px;
      }
      .desc{
        div:nth-child(1){
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 27px;
          margin-top: 27px;
        }
        div:nth-child(2){
          font-size: 36px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 54px;
        }
      }
    }
  }
}
</style>
